export const SHIPPING_ADDRESS_DATA_TERMINATE_LOADING = 'SHIPPING_ADDRESS_DATA_TERMINATE_LOADING';
export const SHIPPING_ADDRESS_UPDATED = 'SHIPPING_ADDRESS_UPDATED';

export function shippingAddressDataTerminateLoading(shippingAddress) {
  return {
    type: SHIPPING_ADDRESS_DATA_TERMINATE_LOADING,
    shippingAddress,
  };
}

export function shippingAddressUpdated(address) {
  return {
    type: SHIPPING_ADDRESS_UPDATED,
    address,
  };
}



// WEBPACK FOOTER //
// ./src/services/SFShippingAddressService/actions.js